import { OrderView, PageReference } from '@gkn-ili/views/src/OrderDocumentation';
import { Model3DXML } from '@gkn-ili/cad-model';

export type AppState = {
  orderView: OrderView;
  activePage: PageReference;
  model: Model3DXML | null;
  view: {
    contentIsOpen: boolean;
    inEditMode: boolean;
  };
  rawModel: Blob | null;
};

export const defaultAppState: AppState = {
  orderView: {
    key: 'loading',
    name: 'loading',
    description: 'loading',
    articleCode: 'loading',
    routing: {
      loading: {
        key: 'loading',
        belongsToKey: 'loading',
        belongsToPosition: 0,
        name: 'loading',
        department: 'SABO',
        type: 'SABO',
        progress: 0,
        status: 'toStart',
        steps: {
          loading: {
            key: 'loading',
            belongsToKey: 'loading',
            belongsToPosition: 0,
            name: 'Loading',
            content: { text: ['Loading...'] },
            status: 'toStart',
            progress: 0,
            activityGroups: {},
            depends: [],
          },
        },
      },
    },
  },
  activePage: { routingItemKey: 'loading', stepKey: 'loading' },
  model: null,
  view: { contentIsOpen: false, inEditMode: true },
  rawModel: null,
};

export type ModifyStateFunction = (setState: (reducer: AppState) => AppState) => void;
